import { CatalogVariantFragmentFragment } from '@notino/shared/definitions/types';

import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

import { useResolvedVoucherDiscount } from '../VoucherDiscount/useResolvedVoucherDiscount';
import { isConditionalDiscount } from '../VoucherDiscount/utils';

export const useIsMinPriceDisplayedInVoucher = (
  variant: CatalogVariantFragmentFragment
) => {
  const { experiment_pd_voucher_bottom_price_information } = useFeatureFlags();
  const voucher = useResolvedVoucherDiscount(variant);

  const isSimpleVoucher = voucher && !isConditionalDiscount(voucher);
  const isSingleConditionVoucher =
    isConditionalDiscount(voucher) && voucher.discountConditions.length === 1;

  return (
    variant.recentMinPrice &&
    experiment_pd_voucher_bottom_price_information &&
    (isSimpleVoucher || isSingleConditionVoucher)
  );
};
